import { Alert, Button } from "react-bootstrap";
import { ErrorBoundary } from "react-error-boundary";

function ErrorFallback({ error, resetErrorBoundary }) {
  console.log(error);

  const subject = encodeURIComponent("App Error Report");
  const body = encodeURIComponent(
    `An error occurred:\n\n${error?.message}\n\nPage: ${window.location.href}`
  );

  return (
    <Alert className="rounded-3 m-4 p-4" variant="danger">
      <Alert.Heading>An error occurred while loading this page</Alert.Heading>

      <p>{error.message}</p>

      <Button
        onClick={() => {
          resetErrorBoundary();
          window.location.reload();
        }}
        variant="danger"
      >
        Please refresh or try again
      </Button>

      {/* Mailto button */}
      <Button
        as="a"
        variant="link"
        href={`mailto:support@excellentbridge.com?subject=${subject}&body=${body}`}
      >
        Report Error
      </Button>
    </Alert>
  );
}

export function AppErrorBoundary({ children }) {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
  );
}
